import {Component, OnInit}      from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatSnackBar}            from '@angular/material/snack-bar';
import {SettingsService}        from '@src/app/core/services/settings.service';
import {ApiService}             from '@src/app/shared/services/api.service';

@Component({
    standalone: false,
    selector: 'app-system-settings',
    templateUrl: './system-settings.component.html',
})
export class SystemSettingsComponent
    implements OnInit
{
    public systemSettingsForm: FormGroup = new FormGroup({
        tenant: new FormGroup({
            timezone: new FormControl('')
        }),
        credits: new FormGroup({
            low_credit_warning: new FormControl<number>(0)
        }),
        pricing: new FormGroup({
            pricing_enabled: new FormControl<boolean>(true)
        }),
    });

    get form()
    {
        return this.systemSettingsForm.controls;
    }

    constructor(
        private apiService: ApiService,
        private snackBar: MatSnackBar,
        private settingsService: SettingsService,
    )
    {
    }

    public ngOnInit(): void
    {
        this.loadSettings();
    }

    public submitCredits()
    {
        if (this.form.credits.valid) {
            this.apiService.updateSettings('settings/credits', this.form.credits.value).subscribe({
                next: response => {
                    this.form.credits.get('low_credit_warning').setValue(response.data.find(c => c.name == 'low_credit_warning').value);
                    this.snackBar.open('You have successfully updated the credits settings.', 'Ok', {duration: 2500});
                },
                error: error => this.apiService.handleError(error)
            });
        } else {
            this.snackBar.open('Please ensure all inputs for the credits section are filled out correctly.', 'Ok', {duration: 2500});
        }
    }

    public submitPricing(): void
    {
        if (this.form.pricing.valid) {
            this.apiService.updateSettings('settings/pricing', this.form.pricing.value).subscribe({
                next: response => {
                    const pricingEnabled = !!response.data.find(setting => setting.name == 'pricing_enabled')?.value;
                    this.form.pricing.get('pricing_enabled').setValue(pricingEnabled);
                    this.settingsService.setPricingEnabled(pricingEnabled);
                    this.snackBar.open('You have successfully updated the pricing settings.', 'Ok', {duration: 2500});
                },
                error: error => this.apiService.handleError(error)
            });
        } else {
            this.snackBar.open('Please ensure the pricing section is filled out correctly.', 'Ok', {duration: 2500});
        }
    }

    private loadSettings(): void
    {
        this.apiService.list('settings').subscribe({
            next: response => {
                this.form.credits.get('low_credit_warning').setValue(response.data.find(setting => setting.name == 'low_credit_warning')?.value ?? 0);
                const pricingEnabled = response.data.find(setting => setting.name == 'pricing_enabled' && setting.feature == 'pricing')?.value ?? true;
                this.form.pricing.get('pricing_enabled').setValue(pricingEnabled);
                this.settingsService.setPricingEnabled(pricingEnabled);
            },
            error: error => this.apiService.handleError(error)
        });
    }
}
